export { default as TopHatSvg } from './TopHatSvg';
export { default as WizardHatSvg } from './WizardHatSvg';
export { default as CrownSvg } from './CrownSvg';
export { default as SunglassesSvg } from './SunglassesSvg';
export { default as RedCollarSvg } from './RedCollarSvg';
export { default as TinySwordSvg } from './TinySwordSvg';
export { default as AngelWingsSvg } from './AngelWingsSvg';
export { default as SantaHatSvg } from './SantaHatSvg';
export { default as PirateHatSvg } from './PirateHatSvg';
export { default as RoundGlassesSvg } from './RoundGlassesSvg';
export { default as PixelGlassesSvg } from './PixelGlassesSvg';
export { default as BlueCollarSvg } from './BlueCollarSvg';
export { default as GoldChainSvg } from './GoldChainSvg';
export { default as SpikedCollarSvg } from './SpikedCollarSvg';
export { default as RedCapeSvg } from './RedCapeSvg';
export { default as BackpackSvg } from './BackpackSvg';
export { default as TinyBootsSvg } from './TinyBootsSvg';
export { default as DiamondSwordSvg } from './DiamondSwordSvg';
export { default as MagicWandSvg } from './MagicWandSvg';
export { default as BatWingsSvg } from './BatWingsSvg';
export { default as RainbowCapeSvg } from './RainbowCapeSvg';
export { default as GlacialCrownSvg } from './GlacialCrownSvg';
export { default as CyborgVisorSvg } from './CyborgVisorSvg';
export { default as PhoenixHelmSvg } from './PhoenixHelmSvg';
export { default as SpaceHelmetSvg } from './SpaceHelmetSvg';
export { default as GasMaskSvg } from './GasMaskSvg';
export { default as HeadphonesSvg } from './HeadphonesSvg';
export { default as BeehiveHatSvg } from './BeehiveHatSvg';
export { default as ChickenHatSvg } from './ChickenHatSvg';
export { default as FrogHatSvg } from './FrogHatSvg';
export { default as PufferfishHatSvg } from './PufferfishHatSvg';
export { default as DragonHeadSvg } from './DragonHeadSvg';
export { default as RageHelmetSvg } from './RageHelmetSvg';
export { default as EntMaskSvg } from './EntMaskSvg';
export { default as BoxBackpackSvg } from './BoxBackpackSvg';
export { default as HeartTrailSvg } from './HeartTrailSvg';
export { default as StarTrailSvg } from './StarTrailSvg';
export { default as FireTrailSvg } from './FireTrailSvg';
export { default as SnowTrailSvg } from './SnowTrailSvg';

// New cosmetic SVG exports
export { default as DragonHeadAetherSvg } from './DragonHeadAetherSvg';
export { default as DragonHeadGreenSvg } from './DragonHeadGreenSvg';
export { default as DragonHeadNetherSvg } from './DragonHeadNetherSvg';
export { default as BearEarsSvg } from './BearEarsSvg';
export { default as CatEarsSvg } from './CatEarsSvg';
export { default as FoxEarsSvg } from './FoxEarsSvg';
export { default as RabbitEarsSvg } from './RabbitEarsSvg';
export { default as WolfEarsSvg } from './WolfEarsSvg';
export { default as TigerEarsSvg } from './TigerEarsSvg';
export { default as CowEarsSvg } from './CowEarsSvg';
export { default as CowHornsSvg } from './CowHornsSvg';
export { default as DeerEarsSvg } from './DeerEarsSvg';
export { default as DeerHornsSvg } from './DeerHornsSvg';
export { default as GoatEarsSvg } from './GoatEarsSvg';
export { default as GoatHornsSvg } from './GoatHornsSvg';
export { default as HorseEarsSvg } from './HorseEarsSvg';
export { default as HorseHornsSvg } from './HorseHornsSvg';
export { default as SheepEarsSvg } from './SheepEarsSvg';
export { default as SheepHornsSvg } from './SheepHornsSvg';
export { default as ArmorerHatSvg } from './ArmorerHatSvg';
export { default as ButcherHatSvg } from './ButcherHatSvg';
export { default as CartographerHatSvg } from './CartographerHatSvg';
export { default as ClericHatSvg } from './ClericHatSvg';
export { default as FletcherHatSvg } from './FletcherHatSvg';
export { default as LibrarianHatSvg } from './LibrarianHatSvg';
export { default as ShepherdHatSvg } from './ShepherdHatSvg';
export { default as WeaponsmithHatSvg } from './WeaponsmithHatSvg';
export { default as DesertVillagerHatSvg } from './DesertVillagerHatSvg';
export { default as SavannaVillagerHatSvg } from './SavannaVillagerHatSvg';
export { default as SnowVillagerHatSvg } from './SnowVillagerHatSvg';
export { default as SwampVillagerHatSvg } from './SwampVillagerHatSvg';
export { default as FarmerHatSvg } from './FarmerHatSvg';
export { default as FishermanHatSvg } from './FishermanHatSvg';
export { default as IllusionerHatSvg } from './IllusionerHatSvg';
export { default as VindicatorHatSvg } from './VindicatorHatSvg';
export { default as SunWizardHatSvg } from './SunWizardHatSvg';
export { default as MoonWizardHatSvg } from './MoonWizardHatSvg';
export { default as DevilHornsSvg } from './DevilHornsSvg';
export { default as TechnoCrownSvg } from './TechnoCrownSvg';
export { default as RoyalCrownSvg } from './RoyalCrownSvg';
export { default as FrankensteinHatSvg } from './FrankensteinHatSvg';
export { default as WitchHatSvg } from './WitchHatSvg';
export { default as WoodenBucketSvg } from './WoodenBucketSvg';
export { default as NewYearsHatSvg } from './NewYearsHatSvg';
export { default as CyborgVisorGreenSvg } from './CyborgVisorGreenSvg';
export { default as CyborgVisorRedSvg } from './CyborgVisorRedSvg';
export { default as RainbowSunglassesSvg } from './RainbowSunglassesSvg';
export { default as XrayGlassesSvg } from './XrayGlassesSvg';
export { default as ThreeDGlassesSvg } from './ThreeDGlassesSvg';
export { default as DealWithItGlassesSvg } from './DealWithItGlassesSvg';
export { default as NeonSunglassesSvg } from './NeonSunglassesSvg';
export { default as TintSunglassesSvg } from './TintSunglassesSvg';
export { default as BlackGlassesSvg } from './BlackGlassesSvg';
export { default as BlackSunglassesSvg } from './BlackSunglassesSvg';
export { default as BrownGlassesSvg } from './BrownGlassesSvg';
export { default as BearTailSvg } from './BearTailSvg';
export { default as CatTailSvg } from './CatTailSvg';
export { default as FoxTailSvg } from './FoxTailSvg';
export { default as RabbitTailSvg } from './RabbitTailSvg';
export { default as WolfTailSvg } from './WolfTailSvg';
export { default as TigerTailSvg } from './TigerTailSvg';
export { default as CowTailSvg } from './CowTailSvg';
export { default as DeerTailSvg } from './DeerTailSvg';
export { default as GoatTailSvg } from './GoatTailSvg';
export { default as SheepTailSvg } from './SheepTailSvg';
export { default as HorseTailSvg } from './HorseTailSvg';
export { default as SunWizardCloakSvg } from './SunWizardCloakSvg';
export { default as MoonWizardCloakSvg } from './MoonWizardCloakSvg';
export { default as TechnoCapeSvg } from './TechnoCapeSvg';
export { default as RoyalCapeSvg } from './RoyalCapeSvg';
export { default as VoltWingsSvg } from './VoltWingsSvg';
export { default as ButterflyWingsOneSvg } from './ButterflyWingsOneSvg';
export { default as ButterflyWingsTwoSvg } from './ButterflyWingsTwoSvg';
export { default as ButterflyWingsThreeSvg } from './ButterflyWingsThreeSvg';
export { default as ButterflyWingsFourSvg } from './ButterflyWingsFourSvg';
export { default as ButterflyWingsFiveSvg } from './ButterflyWingsFiveSvg';
export { default as ButterflyWingsSixSvg } from './ButterflyWingsSixSvg';
export { default as ButterflyWingsSevenSvg } from './ButterflyWingsSevenSvg';
export { default as ButterflyWingsEightSvg } from './ButterflyWingsEightSvg';
export { default as ButterflyWingsNineSvg } from './ButterflyWingsNineSvg';
export { default as ButterflyWingsTenSvg } from './ButterflyWingsTenSvg';
export { default as BoyBackpackSvg } from './BoyBackpackSvg';
export { default as GirlBackpackSvg } from './GirlBackpackSvg';
export { default as BarrelSvg } from './BarrelSvg';
export { default as SunWizardStaffSvg } from './SunWizardStaffSvg';
export { default as MoonWizardStaffSvg } from './MoonWizardStaffSvg';
export { default as TechnoSwordSvg } from './TechnoSwordSvg';
export { default as RoyalStaffSvg } from './RoyalStaffSvg';
export { default as PitchforkSvg } from './PitchforkSvg';
export { default as WoodenWheelSvg } from './WoodenWheelSvg';

// New cosmetic batch (jester, storm, volcano, pixel visor, etc.)
export { default as JesterCapSvg } from './JesterCapSvg';
export { default as StormHaloSvg } from './StormHaloSvg';
export { default as VolcanoPeakSvg } from './VolcanoPeakSvg';
export { default as PixelVisorSvg } from './PixelVisorSvg';
export { default as AstronautFishbowlSvg } from './AstronautFishbowlSvg';
export { default as CatEyeShadesSvg } from './CatEyeShadesSvg';
export { default as GentlemenBowtieSvg } from './GentlemenBowtieSvg';
export { default as ClockworkCollarSvg } from './ClockworkCollarSvg';
export { default as BellNecklaceSvg } from './BellNecklaceSvg';
export { default as LuminousChokerSvg } from './LuminousChokerSvg';
export { default as AuroraShawlSvg } from './AuroraShawlSvg';
export { default as GalaxyCloakSvg } from './GalaxyCloakSvg';
export { default as CandySprinklesSvg } from './CandySprinklesSvg';
export { default as GhostWispsSvg } from './GhostWispsSvg';
export { default as MusicalNoteSvg } from './MusicalNoteSvg';

export const COSMETIC_COMPONENTS = {
  top_hat: require('./TopHatSvg').default,
  wizard_hat: require('./WizardHatSvg').default,
  crown: require('./CrownSvg').default,
  sunglasses: require('./SunglassesSvg').default,
  red_collar: require('./RedCollarSvg').default,
  tiny_sword: require('./TinySwordSvg').default,
  angel_wings: require('./AngelWingsSvg').default,
  santa_hat: require('./SantaHatSvg').default,
  pirate_hat: require('./PirateHatSvg').default,
  round_glasses: require('./RoundGlassesSvg').default,
  pixel_glasses: require('./PixelGlassesSvg').default,
  blue_collar: require('./BlueCollarSvg').default,
  gold_chain: require('./GoldChainSvg').default,
  spiked_collar: require('./SpikedCollarSvg').default,
  red_cape: require('./RedCapeSvg').default,
  backpack: require('./BackpackSvg').default,
  tiny_boots: require('./TinyBootsSvg').default,
  diamond_sword: require('./DiamondSwordSvg').default,
  magic_wand: require('./MagicWandSvg').default,
  // Plus tier
  beret: require('./BeretSvg').default,
  flower_crown: require('./FlowerCrownSvg').default,
  aviator_goggles: require('./AviatorGoggsSvg').default,
  heart_glasses: require('./HeartGlassesSvg').default,
  bow_tie: require('./BowTieSvg').default,
  bandana: require('./BandanaSvg').default,
  wooden_shield: require('./WoodenShieldSvg').default,
  star_wand: require('./StarWandSvg').default,
  butterfly_wings: require('./ButterflyWingsSvg').default,
  scarf: require('./ScarfSvg').default,
  rain_boots: require('./RainBootsSvg').default,
  golden_boots: require('./GoldenBootsSvg').default,
  headphones: require('./HeadphonesSvg').default,
  beehive_hat: require('./BeehiveHatSvg').default,
  chicken_hat: require('./ChickenHatSvg').default,
  frog_hat: require('./FrogHatSvg').default,
  pufferfish_hat: require('./PufferfishHatSvg').default,
  box_backpack: require('./BoxBackpackSvg').default,
  // Premium tier
  bat_wings: require('./BatWingsSvg').default,
  rainbow_cape: require('./RainbowCapeSvg').default,
  glacial_crown: require('./GlacialCrownSvg').default,
  cyborg_visor: require('./CyborgVisorSvg').default,
  phoenix_helm: require('./PhoenixHelmSvg').default,
  space_helmet: require('./SpaceHelmetSvg').default,
  gas_mask: require('./GasMaskSvg').default,
  dragon_head: require('./DragonHeadSvg').default,
  rage_helmet: require('./RageHelmetSvg').default,
  ent_mask: require('./EntMaskSvg').default,
  // Trail cosmetics
  heart_trail: require('./HeartTrailSvg').default,
  star_trail: require('./StarTrailSvg').default,
  fire_trail: require('./FireTrailSvg').default,
  snow_trail: require('./SnowTrailSvg').default,

  // ── New Hats (head slot) ──
  dragon_head_aether: require('./DragonHeadAetherSvg').default,
  dragon_head_green: require('./DragonHeadGreenSvg').default,
  dragon_head_nether: require('./DragonHeadNetherSvg').default,
  bear_ears: require('./BearEarsSvg').default,
  cat_ears: require('./CatEarsSvg').default,
  fox_ears: require('./FoxEarsSvg').default,
  rabbit_ears: require('./RabbitEarsSvg').default,
  wolf_ears: require('./WolfEarsSvg').default,
  tiger_ears: require('./TigerEarsSvg').default,
  cow_ears: require('./CowEarsSvg').default,
  cow_horns: require('./CowHornsSvg').default,
  deer_ears: require('./DeerEarsSvg').default,
  deer_horns: require('./DeerHornsSvg').default,
  goat_ears: require('./GoatEarsSvg').default,
  goat_horns: require('./GoatHornsSvg').default,
  horse_ears: require('./HorseEarsSvg').default,
  horse_horns: require('./HorseHornsSvg').default,
  sheep_ears: require('./SheepEarsSvg').default,
  sheep_horns: require('./SheepHornsSvg').default,
  armorer_hat: require('./ArmorerHatSvg').default,
  butcher_hat: require('./ButcherHatSvg').default,
  cartographer_hat: require('./CartographerHatSvg').default,
  cleric_hat: require('./ClericHatSvg').default,
  fletcher_hat: require('./FletcherHatSvg').default,
  librarian_hat: require('./LibrarianHatSvg').default,
  shepherd_hat: require('./ShepherdHatSvg').default,
  weaponsmith_hat: require('./WeaponsmithHatSvg').default,
  desert_villager_hat: require('./DesertVillagerHatSvg').default,
  savanna_villager_hat: require('./SavannaVillagerHatSvg').default,
  snow_villager_hat: require('./SnowVillagerHatSvg').default,
  swamp_villager_hat: require('./SwampVillagerHatSvg').default,
  farmer_hat: require('./FarmerHatSvg').default,
  fisherman_hat: require('./FishermanHatSvg').default,
  illusioner_hat: require('./IllusionerHatSvg').default,
  vindicator_hat: require('./VindicatorHatSvg').default,
  sun_wizard_hat: require('./SunWizardHatSvg').default,
  moon_wizard_hat: require('./MoonWizardHatSvg').default,
  devil_horns: require('./DevilHornsSvg').default,
  techno_crown: require('./TechnoCrownSvg').default,
  royal_crown: require('./RoyalCrownSvg').default,
  frankenstein_hat: require('./FrankensteinHatSvg').default,
  witch_hat: require('./WitchHatSvg').default,
  wooden_bucket: require('./WoodenBucketSvg').default,
  new_years_hat: require('./NewYearsHatSvg').default,

  // ── New Glasses (eyes slot) ──
  cyborg_visor_green: require('./CyborgVisorGreenSvg').default,
  cyborg_visor_red: require('./CyborgVisorRedSvg').default,
  rainbow_sunglasses: require('./RainbowSunglassesSvg').default,
  xray_glasses: require('./XrayGlassesSvg').default,
  '3d_glasses': require('./ThreeDGlassesSvg').default,
  deal_with_it_glasses: require('./DealWithItGlassesSvg').default,
  neon_sunglasses: require('./NeonSunglassesSvg').default,
  tint_sunglasses: require('./TintSunglassesSvg').default,
  black_glasses: require('./BlackGlassesSvg').default,
  black_sunglasses: require('./BlackSunglassesSvg').default,
  brown_glasses: require('./BrownGlassesSvg').default,

  // ── New Back Items (back slot) ──
  bear_tail: require('./BearTailSvg').default,
  cat_tail: require('./CatTailSvg').default,
  fox_tail: require('./FoxTailSvg').default,
  rabbit_tail: require('./RabbitTailSvg').default,
  wolf_tail: require('./WolfTailSvg').default,
  tiger_tail: require('./TigerTailSvg').default,
  cow_tail: require('./CowTailSvg').default,
  deer_tail: require('./DeerTailSvg').default,
  goat_tail: require('./GoatTailSvg').default,
  sheep_tail: require('./SheepTailSvg').default,
  horse_tail: require('./HorseTailSvg').default,
  sun_wizard_cloak: require('./SunWizardCloakSvg').default,
  moon_wizard_cloak: require('./MoonWizardCloakSvg').default,
  techno_cape: require('./TechnoCapeSvg').default,
  royal_cape: require('./RoyalCapeSvg').default,
  volt_wings: require('./VoltWingsSvg').default,
  butterfly_wings_1: require('./ButterflyWingsOneSvg').default,
  butterfly_wings_2: require('./ButterflyWingsTwoSvg').default,
  butterfly_wings_3: require('./ButterflyWingsThreeSvg').default,
  butterfly_wings_4: require('./ButterflyWingsFourSvg').default,
  butterfly_wings_5: require('./ButterflyWingsFiveSvg').default,
  butterfly_wings_6: require('./ButterflyWingsSixSvg').default,
  butterfly_wings_7: require('./ButterflyWingsSevenSvg').default,
  butterfly_wings_8: require('./ButterflyWingsEightSvg').default,
  butterfly_wings_9: require('./ButterflyWingsNineSvg').default,
  butterfly_wings_10: require('./ButterflyWingsTenSvg').default,
  boy_backpack: require('./BoyBackpackSvg').default,
  girl_backpack: require('./GirlBackpackSvg').default,
  barrel: require('./BarrelSvg').default,

  // ── New Weapons (weapon slot) ──
  sun_wizard_staff: require('./SunWizardStaffSvg').default,
  moon_wizard_staff: require('./MoonWizardStaffSvg').default,
  techno_sword: require('./TechnoSwordSvg').default,
  royal_staff: require('./RoyalStaffSvg').default,
  pitchfork: require('./PitchforkSvg').default,
  wooden_wheel: require('./WoodenWheelSvg').default,

  // ── New batch: themed hats, eyes, neck, capes, trails ──
  jester_cap: require('./JesterCapSvg').default,
  storm_halo: require('./StormHaloSvg').default,
  volcano_peak: require('./VolcanoPeakSvg').default,
  pixel_visor: require('./PixelVisorSvg').default,
  astronaut_fishbowl: require('./AstronautFishbowlSvg').default,
  cat_eye_shades: require('./CatEyeShadesSvg').default,
  gentlemen_bowtie: require('./GentlemenBowtieSvg').default,
  clockwork_collar: require('./ClockworkCollarSvg').default,
  bell_necklace: require('./BellNecklaceSvg').default,
  luminous_choker: require('./LuminousChokerSvg').default,
  aurora_shawl: require('./AuroraShawlSvg').default,
  galaxy_cloak: require('./GalaxyCloakSvg').default,
  candy_sprinkles: require('./CandySprinklesSvg').default,
  ghost_wisps: require('./GhostWispsSvg').default,
  musical_note: require('./MusicalNoteSvg').default,

  // Aliases matching backend item IDs after the `unlock_` prefix is
  // stripped (Shop.js:201). Without these, the catalog/shop renders no
  // icon for the Candy Sprinkles tail and the two earnable trails.
  candy_sprinkles_tail: require('./CandySprinklesSvg').default,
  ghost_wisps_trail: require('./GhostWispsSvg').default,
  musical_note_trail: require('./MusicalNoteSvg').default,
};

/**
 * The voxel art when the item has it, and the hand-drawn SVG otherwise.
 */
export function getCosmeticComponent(cosmeticId) {
  const { artCosmeticComponent } = require('./ArtCosmetic');
  return artCosmeticComponent(cosmeticId) || COSMETIC_COMPONENTS[cosmeticId] || null;
}

// Attachment points for cosmetics per pet type
// Values are percentage offsets from top-left of the pet SVG
export const ATTACHMENT_POINTS = {
  cat: { head: { x: 50, y: 18 }, eyes: { x: 50, y: 30 }, neck: { x: 50, y: 48 }, back: { x: 50, y: 45 }, weapon: { x: 82, y: 60 } },
  wolf: { head: { x: 50, y: 14 }, eyes: { x: 50, y: 28 }, neck: { x: 50, y: 48 }, back: { x: 50, y: 42 }, weapon: { x: 85, y: 55 } },
  fox: { head: { x: 50, y: 16 }, eyes: { x: 50, y: 28 }, neck: { x: 50, y: 48 }, back: { x: 50, y: 44 }, weapon: { x: 82, y: 58 } },
  rabbit: { head: { x: 50, y: 10 }, neck: { x: 50, y: 50 }, back: { x: 50, y: 46 }, weapon: { x: 80, y: 60 } },
  parrot: { head: { x: 50, y: 10 }, neck: { x: 50, y: 42 }, back: { x: 50, y: 38 }, weapon: { x: 80, y: 55 } },
  axolotl: { head: { x: 50, y: 18 }, neck: { x: 50, y: 46 }, back: { x: 50, y: 42 }, weapon: { x: 82, y: 58 } },
  panda: { head: { x: 50, y: 10 }, neck: { x: 50, y: 46 }, back: { x: 50, y: 40 }, weapon: { x: 84, y: 58 } },
  baby_dragon: { head: { x: 50, y: 12 }, neck: { x: 50, y: 42 }, back: { x: 50, y: 38 }, weapon: { x: 82, y: 55 } },
  slime: { head: { x: 50, y: 14 }, neck: { x: 50, y: 50 }, back: { x: 50, y: 40 }, weapon: { x: 78, y: 55 } },
  strider: { head: { x: 50, y: 12 }, neck: { x: 50, y: 38 }, back: { x: 50, y: 34 }, weapon: { x: 80, y: 50 } },
  polar_bear: { head: { x: 50, y: 10 }, neck: { x: 50, y: 42 }, back: { x: 50, y: 38 }, weapon: { x: 84, y: 55 } },
  iron_golem: { head: { x: 50, y: 6 }, neck: { x: 50, y: 38 }, back: { x: 50, y: 34 }, weapon: { x: 86, y: 55 } },
  snow_golem: { head: { x: 50, y: 8 }, neck: { x: 50, y: 42 }, back: { x: 50, y: 38 }, weapon: { x: 82, y: 50 } },
  horse: { head: { x: 30, y: 10 }, neck: { x: 38, y: 38 }, back: { x: 55, y: 40 }, weapon: { x: 85, y: 58 } },
  llama: { head: { x: 40, y: 8 }, neck: { x: 42, y: 40 }, back: { x: 60, y: 42 }, weapon: { x: 85, y: 58 } },
  wisp: { head: { x: 50, y: 16 }, neck: { x: 50, y: 46 }, back: { x: 50, y: 40 }, weapon: { x: 80, y: 50 } },
  default: { head: { x: 50, y: 16 }, eyes: { x: 50, y: 28 }, neck: { x: 50, y: 48 }, back: { x: 50, y: 42 }, weapon: { x: 80, y: 58 } },
};
// The pets are drawn from voxel art now; its anchors replace the ones above,
// which fitted the old hand-drawn SVG pets.
Object.assign(ATTACHMENT_POINTS, require('./artAttachmentPoints').ART_ATTACHMENT_POINTS);


// COSMETIC_SLOTS and COSMETIC_CATALOG removed - now sourced from backend /catalog/all.
// Use useCosmeticCatalog() and useCosmeticSlots() from CatalogContext instead.

const _LEGACY_COSMETIC_SLOTS = {
  top_hat: 'head',
  wizard_hat: 'head',
  crown: 'head',
  santa_hat: 'head',
  pirate_hat: 'head',
  sunglasses: 'eyes',
  round_glasses: 'eyes',
  pixel_glasses: 'eyes',
  red_collar: 'neck',
  blue_collar: 'neck',
  gold_chain: 'neck',
  spiked_collar: 'neck',
  tiny_sword: 'weapon',
  diamond_sword: 'weapon',
  magic_wand: 'weapon',
  angel_wings: 'back',
  red_cape: 'back',
  backpack: 'back',
  tiny_boots: 'feet',
  // Plus tier
  beret: 'head',
  flower_crown: 'head',
  aviator_goggles: 'eyes',
  heart_glasses: 'eyes',
  bow_tie: 'neck',
  bandana: 'neck',
  wooden_shield: 'weapon',
  star_wand: 'weapon',
  butterfly_wings: 'back',
  scarf: 'back',
  rain_boots: 'feet',
  golden_boots: 'feet',
  headphones: 'eyes',
  beehive_hat: 'head',
  chicken_hat: 'head',
  frog_hat: 'head',
  pufferfish_hat: 'head',
  box_backpack: 'back',
  // Premium tier
  bat_wings: 'back',
  rainbow_cape: 'back',
  glacial_crown: 'head',
  cyborg_visor: 'eyes',
  phoenix_helm: 'head',
  space_helmet: 'head',
  gas_mask: 'eyes',
  dragon_head: 'head',
  rage_helmet: 'head',
  ent_mask: 'head',
  // Trail cosmetics
  heart_trail: 'trail',
  star_trail: 'trail',
  fire_trail: 'trail',
  snow_trail: 'trail',

  // ── New Hats (head slot) ──
  dragon_head_aether: 'head',
  dragon_head_green: 'head',
  dragon_head_nether: 'head',
  bear_ears: 'head',
  cat_ears: 'head',
  fox_ears: 'head',
  rabbit_ears: 'head',
  wolf_ears: 'head',
  tiger_ears: 'head',
  cow_ears: 'head',
  cow_horns: 'head',
  deer_ears: 'head',
  deer_horns: 'head',
  goat_ears: 'head',
  goat_horns: 'head',
  horse_ears: 'head',
  horse_horns: 'head',
  sheep_ears: 'head',
  sheep_horns: 'head',
  armorer_hat: 'head',
  butcher_hat: 'head',
  cartographer_hat: 'head',
  cleric_hat: 'head',
  fletcher_hat: 'head',
  librarian_hat: 'head',
  shepherd_hat: 'head',
  weaponsmith_hat: 'head',
  desert_villager_hat: 'head',
  savanna_villager_hat: 'head',
  snow_villager_hat: 'head',
  swamp_villager_hat: 'head',
  farmer_hat: 'head',
  fisherman_hat: 'head',
  illusioner_hat: 'head',
  vindicator_hat: 'head',
  sun_wizard_hat: 'head',
  moon_wizard_hat: 'head',
  devil_horns: 'head',
  techno_crown: 'head',
  royal_crown: 'head',
  frankenstein_hat: 'head',
  witch_hat: 'head',
  wooden_bucket: 'head',
  new_years_hat: 'head',

  // ── New Glasses (eyes slot) ──
  cyborg_visor_green: 'eyes',
  cyborg_visor_red: 'eyes',
  rainbow_sunglasses: 'eyes',
  xray_glasses: 'eyes',
  '3d_glasses': 'eyes',
  deal_with_it_glasses: 'eyes',
  neon_sunglasses: 'eyes',
  tint_sunglasses: 'eyes',
  black_glasses: 'eyes',
  black_sunglasses: 'eyes',
  brown_glasses: 'eyes',

  // ── New Back Items (back slot) ──
  bear_tail: 'back',
  cat_tail: 'back',
  fox_tail: 'back',
  rabbit_tail: 'back',
  wolf_tail: 'back',
  tiger_tail: 'back',
  cow_tail: 'back',
  deer_tail: 'back',
  goat_tail: 'back',
  sheep_tail: 'back',
  horse_tail: 'back',
  sun_wizard_cloak: 'cape',
  moon_wizard_cloak: 'cape',
  techno_cape: 'cape',
  royal_cape: 'cape',
  volt_wings: 'back',
  butterfly_wings_1: 'back',
  butterfly_wings_2: 'back',
  butterfly_wings_3: 'back',
  butterfly_wings_4: 'back',
  butterfly_wings_5: 'back',
  butterfly_wings_6: 'back',
  butterfly_wings_7: 'back',
  butterfly_wings_8: 'back',
  butterfly_wings_9: 'back',
  butterfly_wings_10: 'back',
  boy_backpack: 'back',
  girl_backpack: 'back',
  barrel: 'back',

  // ── New Weapons (weapon slot) ──
  sun_wizard_staff: 'weapon',
  moon_wizard_staff: 'weapon',
  techno_sword: 'weapon',
  royal_staff: 'weapon',
  pitchfork: 'weapon',
  wooden_wheel: 'weapon',

  // ── New batch slot assignments ──
  jester_cap: 'head',
  storm_halo: 'head',
  volcano_peak: 'head',
  pixel_visor: 'eyes',
  astronaut_fishbowl: 'head',
  cat_eye_shades: 'eyes',
  gentlemen_bowtie: 'neck',
  clockwork_collar: 'neck',
  bell_necklace: 'neck',
  luminous_choker: 'neck',
  aurora_shawl: 'cape',
  galaxy_cloak: 'cape',
  candy_sprinkles: 'trail',
  ghost_wisps: 'trail',
  musical_note: 'trail',
};

const _LEGACY_COSMETIC_CATALOG = [
  { id: 'top_hat', name: 'Top Hat', slot: 'head', tier: 'free' },
  { id: 'wizard_hat', name: 'Wizard Hat', slot: 'head', tier: 'free' },
  { id: 'crown', name: 'Royal Crown', slot: 'head', tier: 'premium' },
  { id: 'sunglasses', name: 'Sunglasses', slot: 'eyes', tier: 'free' },
  { id: 'santa_hat', name: 'Santa Hat', slot: 'head', tier: 'free' },
  { id: 'pirate_hat', name: 'Pirate Hat', slot: 'head', tier: 'premium' },
  { id: 'round_glasses', name: 'Round Glasses', slot: 'eyes', tier: 'free' },
  { id: 'pixel_glasses', name: 'Pixel Glasses', slot: 'eyes', tier: 'premium' },
  { id: 'red_collar', name: 'Red Collar', slot: 'neck', tier: 'free' },
  { id: 'blue_collar', name: 'Blue Collar', slot: 'neck', tier: 'free' },
  { id: 'gold_chain', name: 'Gold Chain', slot: 'neck', tier: 'premium' },
  { id: 'spiked_collar', name: 'Spiked Collar', slot: 'neck', tier: 'premium' },
  { id: 'tiny_sword', name: 'Tiny Sword', slot: 'weapon', tier: 'free' },
  { id: 'diamond_sword', name: 'Diamond Sword', slot: 'weapon', tier: 'premium' },
  { id: 'magic_wand', name: 'Magic Wand', slot: 'weapon', tier: 'premium' },
  { id: 'angel_wings', name: 'Angel Wings', slot: 'back', tier: 'premium' },
  { id: 'red_cape', name: 'Red Cape', slot: 'back', tier: 'free' },
  { id: 'backpack', name: 'Backpack', slot: 'back', tier: 'free' },
  { id: 'tiny_boots', name: 'Tiny Boots', slot: 'feet', tier: 'free' },

  // Plus tier cosmetics
  { id: 'beret', name: 'Beret', slot: 'head', tier: 'plus' },
  { id: 'flower_crown', name: 'Flower Crown', slot: 'head', tier: 'plus' },
  { id: 'aviator_goggles', name: 'Aviator Goggles', slot: 'eyes', tier: 'plus' },
  { id: 'heart_glasses', name: 'Heart Glasses', slot: 'eyes', tier: 'plus' },
  { id: 'bow_tie', name: 'Bow Tie', slot: 'neck', tier: 'plus' },
  { id: 'bandana', name: 'Bandana', slot: 'neck', tier: 'plus' },
  { id: 'wooden_shield', name: 'Wooden Shield', slot: 'weapon', tier: 'plus' },
  { id: 'star_wand', name: 'Star Wand', slot: 'weapon', tier: 'plus' },
  { id: 'butterfly_wings', name: 'Butterfly Wings', slot: 'back', tier: 'plus' },
  { id: 'scarf', name: 'Scarf', slot: 'back', tier: 'plus' },
  { id: 'rain_boots', name: 'Rain Boots', slot: 'feet', tier: 'plus' },
  { id: 'golden_boots', name: 'Golden Boots', slot: 'feet', tier: 'premium' },
  { id: 'headphones', name: 'Headphones', slot: 'eyes', tier: 'plus' },
  { id: 'beehive_hat', name: 'Beehive Hat', slot: 'head', tier: 'plus' },
  { id: 'chicken_hat', name: 'Chicken Hat', slot: 'head', tier: 'plus' },
  { id: 'frog_hat', name: 'Frog Hat', slot: 'head', tier: 'plus' },
  { id: 'pufferfish_hat', name: 'Pufferfish Hat', slot: 'head', tier: 'plus' },
  { id: 'box_backpack', name: 'Box Backpack', slot: 'back', tier: 'plus' },

  // Premium tier cosmetics
  { id: 'bat_wings', name: 'Bat Wings', slot: 'back', tier: 'premium' },
  { id: 'rainbow_cape', name: 'Rainbow Cape', slot: 'back', tier: 'individual' },
  { id: 'glacial_crown', name: 'Glacial Crown', slot: 'head', tier: 'individual' },
  { id: 'cyborg_visor', name: 'Cyborg Visor', slot: 'eyes', tier: 'premium' },
  { id: 'phoenix_helm', name: 'Phoenix Helm', slot: 'head', tier: 'premium' },
  { id: 'space_helmet', name: 'Space Helmet', slot: 'head', tier: 'individual' },
  { id: 'gas_mask', name: 'Gas Mask', slot: 'eyes', tier: 'premium' },
  { id: 'dragon_head', name: 'Dragon Head', slot: 'head', tier: 'individual' },
  { id: 'rage_helmet', name: 'Rage Helmet', slot: 'head', tier: 'premium' },
  { id: 'ent_mask', name: 'Ent Mask', slot: 'head', tier: 'premium' },

  // Trail cosmetics
  { id: 'heart_trail', name: 'Heart Trail', slot: 'trail', tier: 'plus' },
  { id: 'star_trail', name: 'Star Trail', slot: 'trail', tier: 'plus' },
  { id: 'fire_trail', name: 'Fire Trail', slot: 'trail', tier: 'individual' },
  { id: 'snow_trail', name: 'Snow Trail', slot: 'trail', tier: 'premium' },

  // Consumable item for trait reroll
  { id: 'trait_reroll', name: 'Trait Reroll', slot: 'none', tier: 'plus' },

  // ── New Hats (head slot) ──
  { id: 'dragon_head_aether', name: 'Dragon Head Aether', slot: 'head', tier: 'premium' },
  { id: 'dragon_head_green', name: 'Dragon Head Green', slot: 'head', tier: 'premium' },
  { id: 'dragon_head_nether', name: 'Dragon Head Nether', slot: 'head', tier: 'premium' },
  { id: 'bear_ears', name: 'Bear Ears', slot: 'head', tier: 'plus' },
  { id: 'cat_ears', name: 'Cat Ears', slot: 'head', tier: 'plus' },
  { id: 'fox_ears', name: 'Fox Ears', slot: 'head', tier: 'plus' },
  { id: 'rabbit_ears', name: 'Rabbit Ears', slot: 'head', tier: 'plus' },
  { id: 'wolf_ears', name: 'Wolf Ears', slot: 'head', tier: 'plus' },
  { id: 'tiger_ears', name: 'Tiger Ears', slot: 'head', tier: 'premium' },
  { id: 'cow_ears', name: 'Cow Ears', slot: 'head', tier: 'plus' },
  { id: 'cow_horns', name: 'Cow Horns', slot: 'head', tier: 'plus' },
  { id: 'deer_ears', name: 'Deer Ears', slot: 'head', tier: 'plus' },
  { id: 'deer_horns', name: 'Deer Horns', slot: 'head', tier: 'premium' },
  { id: 'goat_ears', name: 'Goat Ears', slot: 'head', tier: 'plus' },
  { id: 'goat_horns', name: 'Goat Horns', slot: 'head', tier: 'plus' },
  { id: 'horse_ears', name: 'Horse Ears', slot: 'head', tier: 'plus' },
  { id: 'horse_horns', name: 'Horse Horns', slot: 'head', tier: 'premium' },
  { id: 'sheep_ears', name: 'Sheep Ears', slot: 'head', tier: 'plus' },
  { id: 'sheep_horns', name: 'Sheep Horns', slot: 'head', tier: 'plus' },
  { id: 'armorer_hat', name: 'Armorer Hat', slot: 'head', tier: 'plus' },
  { id: 'butcher_hat', name: 'Butcher Hat', slot: 'head', tier: 'plus' },
  { id: 'cartographer_hat', name: 'Cartographer Hat', slot: 'head', tier: 'plus' },
  { id: 'cleric_hat', name: 'Cleric Hat', slot: 'head', tier: 'plus' },
  { id: 'fletcher_hat', name: 'Fletcher Hat', slot: 'head', tier: 'plus' },
  { id: 'librarian_hat', name: 'Librarian Hat', slot: 'head', tier: 'plus' },
  { id: 'shepherd_hat', name: 'Shepherd Hat', slot: 'head', tier: 'plus' },
  { id: 'weaponsmith_hat', name: 'Weaponsmith Hat', slot: 'head', tier: 'plus' },
  { id: 'desert_villager_hat', name: 'Desert Villager Hat', slot: 'head', tier: 'plus' },
  { id: 'savanna_villager_hat', name: 'Savanna Villager Hat', slot: 'head', tier: 'plus' },
  { id: 'snow_villager_hat', name: 'Snow Villager Hat', slot: 'head', tier: 'plus' },
  { id: 'swamp_villager_hat', name: 'Swamp Villager Hat', slot: 'head', tier: 'plus' },
  { id: 'farmer_hat', name: 'Farmer Hat', slot: 'head', tier: 'free' },
  { id: 'fisherman_hat', name: 'Fisherman Hat', slot: 'head', tier: 'free' },
  { id: 'illusioner_hat', name: 'Illusioner Hat', slot: 'head', tier: 'premium' },
  { id: 'vindicator_hat', name: 'Vindicator Hat', slot: 'head', tier: 'premium' },
  { id: 'sun_wizard_hat', name: 'Sun Wizard Hat', slot: 'head', tier: 'individual' },
  { id: 'moon_wizard_hat', name: 'Moon Wizard Hat', slot: 'head', tier: 'individual' },
  { id: 'devil_horns', name: 'Devil Horns', slot: 'head', tier: 'premium' },
  { id: 'techno_crown', name: 'Techno Crown', slot: 'head', tier: 'individual' },
  { id: 'royal_crown', name: 'Royal Crown', slot: 'head', tier: 'individual' },
  { id: 'frankenstein_hat', name: 'Frankenstein Hat', slot: 'head', tier: 'plus' },
  { id: 'witch_hat', name: 'Witch Hat', slot: 'head', tier: 'plus' },
  { id: 'wooden_bucket', name: 'Wooden Bucket', slot: 'head', tier: 'plus' },
  { id: 'new_years_hat', name: 'New Years Hat', slot: 'head', tier: 'plus' },

  // ── New Glasses (eyes slot) ──
  { id: 'cyborg_visor_green', name: 'Cyborg Visor Green', slot: 'eyes', tier: 'premium' },
  { id: 'cyborg_visor_red', name: 'Cyborg Visor Red', slot: 'eyes', tier: 'premium' },
  { id: 'rainbow_sunglasses', name: 'Rainbow Sunglasses', slot: 'eyes', tier: 'premium' },
  { id: 'xray_glasses', name: 'X-Ray Glasses', slot: 'eyes', tier: 'premium' },
  { id: '3d_glasses', name: '3D Glasses', slot: 'eyes', tier: 'plus' },
  { id: 'deal_with_it_glasses', name: 'Deal With It Glasses', slot: 'eyes', tier: 'plus' },
  { id: 'neon_sunglasses', name: 'Neon Sunglasses', slot: 'eyes', tier: 'plus' },
  { id: 'tint_sunglasses', name: 'Tint Sunglasses', slot: 'eyes', tier: 'plus' },
  { id: 'black_glasses', name: 'Black Glasses', slot: 'eyes', tier: 'free' },
  { id: 'black_sunglasses', name: 'Black Sunglasses', slot: 'eyes', tier: 'free' },
  { id: 'brown_glasses', name: 'Brown Glasses', slot: 'eyes', tier: 'free' },

  // ── New Back Items (back slot) ──
  { id: 'bear_tail', name: 'Bear Tail', slot: 'back', tier: 'plus' },
  { id: 'cat_tail', name: 'Cat Tail', slot: 'back', tier: 'plus' },
  { id: 'fox_tail', name: 'Fox Tail', slot: 'back', tier: 'plus' },
  { id: 'rabbit_tail', name: 'Rabbit Tail', slot: 'back', tier: 'plus' },
  { id: 'wolf_tail', name: 'Wolf Tail', slot: 'back', tier: 'plus' },
  { id: 'tiger_tail', name: 'Tiger Tail', slot: 'back', tier: 'premium' },
  { id: 'cow_tail', name: 'Cow Tail', slot: 'back', tier: 'plus' },
  { id: 'deer_tail', name: 'Deer Tail', slot: 'back', tier: 'plus' },
  { id: 'goat_tail', name: 'Goat Tail', slot: 'back', tier: 'plus' },
  { id: 'sheep_tail', name: 'Sheep Tail', slot: 'back', tier: 'plus' },
  { id: 'horse_tail', name: 'Horse Tail', slot: 'back', tier: 'premium' },
  { id: 'sun_wizard_cloak', name: 'Sun Wizard Cloak', slot: 'cape', tier: 'premium' },
  { id: 'moon_wizard_cloak', name: 'Moon Wizard Cloak', slot: 'cape', tier: 'premium' },
  { id: 'techno_cape', name: 'Techno Cape', slot: 'cape', tier: 'individual' },
  { id: 'royal_cape', name: 'Royal Cape', slot: 'cape', tier: 'individual' },
  { id: 'volt_wings', name: 'Volt Wings', slot: 'back', tier: 'individual' },
  { id: 'butterfly_wings_1', name: 'Butterfly Wings 1', slot: 'back', tier: 'plus' },
  { id: 'butterfly_wings_2', name: 'Butterfly Wings 2', slot: 'back', tier: 'plus' },
  { id: 'butterfly_wings_3', name: 'Butterfly Wings 3', slot: 'back', tier: 'plus' },
  { id: 'butterfly_wings_4', name: 'Butterfly Wings 4', slot: 'back', tier: 'plus' },
  { id: 'butterfly_wings_5', name: 'Butterfly Wings 5', slot: 'back', tier: 'premium' },
  { id: 'butterfly_wings_6', name: 'Butterfly Wings 6', slot: 'back', tier: 'plus' },
  { id: 'butterfly_wings_7', name: 'Butterfly Wings 7', slot: 'back', tier: 'plus' },
  { id: 'butterfly_wings_8', name: 'Butterfly Wings 8', slot: 'back', tier: 'plus' },
  { id: 'butterfly_wings_9', name: 'Butterfly Wings 9', slot: 'back', tier: 'premium' },
  { id: 'butterfly_wings_10', name: 'Butterfly Wings 10', slot: 'back', tier: 'individual' },
  { id: 'boy_backpack', name: 'Boy Backpack', slot: 'back', tier: 'plus' },
  { id: 'girl_backpack', name: 'Girl Backpack', slot: 'back', tier: 'plus' },
  { id: 'barrel', name: 'Barrel', slot: 'back', tier: 'plus' },

  // ── New Weapons (weapon slot) ──
  { id: 'sun_wizard_staff', name: 'Sun Wizard Staff', slot: 'weapon', tier: 'premium' },
  { id: 'moon_wizard_staff', name: 'Moon Wizard Staff', slot: 'weapon', tier: 'premium' },
  { id: 'techno_sword', name: 'Techno Sword', slot: 'weapon', tier: 'individual' },
  { id: 'royal_staff', name: 'Royal Staff', slot: 'weapon', tier: 'individual' },
  { id: 'pitchfork', name: 'Pitchfork', slot: 'weapon', tier: 'plus' },
  { id: 'wooden_wheel', name: 'Wooden Wheel', slot: 'weapon', tier: 'plus' },
];

// ── Emote Catalog ──
export const EMOTE_CATEGORIES = ['Greetings', 'Dances', 'Expressions', 'Actions', 'Tricks'];

export const EMOTE_CATALOG = [
  // Greetings
  { id: 'wave', name: 'Wave', category: 'Greetings', price: 0, description: 'A friendly wave!', duration: 1.5 },
  { id: 'nod', name: 'Nod', category: 'Greetings', price: 0, description: 'A simple nod of acknowledgment.', duration: 1.0 },
  { id: 'bow', name: 'Bow', category: 'Greetings', price: 25, description: 'A respectful bow.', duration: 2.0 },
  // Dances
  { id: 'spin', name: 'Spin', category: 'Dances', price: 0, description: 'Spin around in circles!', duration: 2.0, loop: true },
  { id: 'hop_dance', name: 'Hop Dance', category: 'Dances', price: 30, description: 'Happy hopping dance!', duration: 3.0, loop: true },
  { id: 'wiggle', name: 'Wiggle', category: 'Dances', price: 30, description: 'A cute wiggle dance.', duration: 2.5, loop: true },
  // Expressions
  { id: 'happy_jump', name: 'Happy Jump', category: 'Expressions', price: 0, description: 'Jump for joy!', duration: 1.25, particles: 'stars' },
  { id: 'confused', name: 'Confused', category: 'Expressions', price: 0, description: 'Tilt head in confusion.', duration: 1.75 },
  { id: 'sad_droop', name: 'Sad Droop', category: 'Expressions', price: 20, description: 'Looking sad and droopy.', duration: 3.0 },
  { id: 'angry_stomp', name: 'Angry Stomp', category: 'Expressions', price: 20, description: 'Stomp those tiny paws!', duration: 1.5, particles: 'impact' },
  { id: 'love_hearts', name: 'Love Hearts', category: 'Expressions', price: 35, description: 'Show love with floating hearts!', duration: 2.0, particles: 'hearts' },
  // Actions
  { id: 'sit', name: 'Sit', category: 'Actions', price: 0, description: 'Sit down obediently.', duration: 5.0, loop: true },
  { id: 'beg', name: 'Beg', category: 'Actions', price: 0, description: 'Beg for treats!', duration: 3.0, loop: true },
  { id: 'roll_over', name: 'Roll Over', category: 'Actions', price: 25, description: 'Roll over on the ground.', duration: 2.5 },
  { id: 'play_dead', name: 'Play Dead', category: 'Actions', price: 40, description: 'Dramatically play dead!', duration: 4.0 },
  { id: 'sleep', name: 'Sleep', category: 'Actions', price: 50, description: 'Curl up and sleep. ZZZ...', duration: 10.0, loop: true, particles: 'zzz' },
  // Tricks
  { id: 'backflip', name: 'Backflip', category: 'Tricks', price: 40, description: 'An impressive backflip!', duration: 1.5 },
  { id: 'handstand', name: 'Handstand', category: 'Tricks', price: 50, description: 'Balance on front paws!', duration: 3.0 },
  { id: 'fetch_ball', name: 'Fetch', category: 'Tricks', price: 60, description: 'Chase an invisible ball!', duration: 4.0 },
];
